import React from 'react';

import {
  trackDemoExistingEmailModalContinue,
  trackDemoExistingEmailModalUseNewEmail,
} from '../../../analytics';

import { Button, Modal } from '../../../components/general';

import useDemoData from '../../../hooks/useDemoData';

import { DemoData } from '../../../types';

interface Props {
  show: boolean;
  onHide: () => void;
  userData: DemoData;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}

const ExistingEmailModal: React.FC<Props> = (props) => {
  const { show, onHide, userData, setStep } = props;

  const { updateDemoData } = useDemoData();

  const step = userData.status;

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Body centered>
        <h4>You've used this email before</h4>

        <div>
          We found an existing demo for this address. You can pick up where you
          left off at the <b>{step} step</b>, or start fresh with a different
          email.
        </div>

        <div className="w-full flex flex-col sm:flex-row gap-4">
          <Button
            onClick={() => {
              updateDemoData(userData);
              setStep(step === 'generation' ? 3 : 2);
              trackDemoExistingEmailModalContinue(step);
              onHide();
            }}
            className="w-full sm:w-1/2 capitalize"
          >
            Continue {step}
          </Button>

          <Button
            onClick={() => {
              trackDemoExistingEmailModalUseNewEmail();
              onHide();
            }}
            colour="pink"
            className="w-full sm:w-1/2"
          >
            Use A Different Email
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ExistingEmailModal;
